/**
 * Created by Holger Szuesz <development@szuesz.de> on 18.07.2018 16:59
 */

import * as React from 'react';
import Navigation from "./Navigation";

import '../styles/Header.css';

class Header extends React.Component {
    public render() {
        return (
            <header className="masthead">
                <div className="inner">
                    <h3 className="masthead-brand">Einfach anders</h3>
                    <Navigation/>
                </div>
            </header>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.tsx